<a-header stream-title="Edu Admin" padding="false">
  @let model = viewModel();

  @for (item of model.navItems; track item.path) {
    <a-header-item
      slot="start"
      [routerLink]="item.path"
      [attr.active]="item.active ? '' : null"
    >
      {{ item.label }}
    </a-header-item>
  }
</a-header>
